import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  ref: "el",
  class: "relative inline-block"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to delete this idea? This can't be undone.", -1)
const _hoisted_3 = { class: "flex justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionMenuIcon = _resolveComponent("ActionMenuIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "mb-3 sm:mb-0 sm:ml-4 p-2 border-2 border-cebai-grey-light rounded-full hover:bg-cebai-grey-lightest",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOpenState && _ctx.toggleOpenState(...args)), ["stop"]))
      }, [
        _createVNode(_component_ActionMenuIcon, { class: "text-cebai-primary fill-current" })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute z-10 p-2 inline-block top-full right-0 rounded-xl transition-all duration-300 bg-cebai-base-light shadow-[0_0_20px_0_rgba(51,51,51,0.2)]", {
        'mt-2 visible opacity-100': _ctx.isOpen,
        '-mt-2 invisible opacity-0': !_ctx.isOpen,
      }])
      }, [
        _createElementVNode("button", {
          class: "block w-full text-left px-4 py-2 text-md font-robotoBold whitespace-nowrap rounded-lg transition bg-cebai-grey-lightest hover:bg-cebai-grey-light text-cebai-grey-dark hover:text-cebai-base-dark mb-2",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleExpandIdea && _ctx.handleExpandIdea(...args)), ["stop"]))
        }, [
          (_ctx.challengeIsActive)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Edit idea")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("View details")
              ], 64))
        ]),
        (_ctx.challengeIsActive)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "block w-full text-left px-4 py-2 text-md font-robotoBold whitespace-nowrap rounded-lg transition bg-cebai-grey-lightest hover:bg-cebai-grey-light text-cebai-grey-dark hover:text-cebai-base-dark",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showDeleteIdeaModal && _ctx.showDeleteIdeaModal(...args)), ["stop"]))
            }, " Delete idea "))
          : _createCommentVNode("", true)
      ], 2)
    ], 512),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.deleteIdea,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isShown.deleteIdea) = $event)),
      close: () => _ctx.closeModal('deleteIdea')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('deleteIdea'),
          title: "Delete idea",
          class: "md:max-w-xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_AppButton, {
                    class: "mr-2",
                    type: "secondary",
                    onClick: _cache[3] || (_cache[3] = () => _ctx.closeModal('deleteIdea'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppButton, {
                    type: "danger",
                    onClick: _ctx.handleDeleteIdea
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Delete")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"])
  ], 64))
}